
        import { TypePolicies } from "@apollo/client";
        const typePolicies:TypePolicies ={
          Query: {
            fields: {
              appRevisionBom: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AppRevisionBom',
                      id: args.id,
                    });
                  }
                },
              appStatus: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AppStatus',
                      id: args.id,
                    });
                  }
                },
              assertion: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Assertion',
                      id: args.id,
                    });
                  }
                },
              assertionType: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssertionType',
                      id: args.id,
                    });
                  }
                },
              assetAttribute: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetAttribute',
                      id: args.id,
                    });
                  }
                },
              assetAttributeModelDefaultValue: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetAttributeModelDefaultValue',
                      id: args.id,
                    });
                  }
                },
              assetAttributeSet: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetAttributeSet',
                      id: args.id,
                    });
                  }
                },
              assetAttributeUnit: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetAttributeUnit',
                      id: args.id,
                    });
                  }
                },
              assetAttributeValue: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetAttributeValue',
                      id: args.id,
                    });
                  }
                },
              assetBridgeAssetTag: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetBridgeAssetTag',
                      id: args.id,
                    });
                  }
                },
              asset: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Asset',
                      id: args.id,
                    });
                  }
                },
              assetModelBridgeAssetAttributeSet: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetModelBridgeAssetAttributeSet',
                      id: args.id,
                    });
                  }
                },
              assetModel: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetModel',
                      id: args.id,
                    });
                  }
                },
              assetModelTree: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetModelTree',
                      id: args.id,
                    });
                  }
                },
              assetModelTreeNode: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetModelTreeNode',
                      id: args.id,
                    });
                  }
                },
              assetTag: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetTag',
                      id: args.id,
                    });
                  }
                },
              assetType: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetType',
                      id: args.id,
                    });
                  }
                },
              assetTypeTree: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetTypeTree',
                      id: args.id,
                    });
                  }
                },
              assetTypeTreeNode: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AssetTypeTreeNode',
                      id: args.id,
                    });
                  }
                },
              autoUpdateMode: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'AutoUpdateMode',
                      id: args.id,
                    });
                  }
                },
              component: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Component',
                      id: args.id,
                    });
                  }
                },
              deploymentGroupAdministrator: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroupAdministrator',
                      id: args.id,
                    });
                  }
                },
              deploymentGroupBridgeAppRevision: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroupBridgeAppRevision',
                      id: args.id,
                    });
                  }
                },
              deploymentGroupBridgeDeploymentGroupTag: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroupBridgeDeploymentGroupTag',
                      id: args.id,
                    });
                  }
                },
              deploymentGroupBridgeSoftwareRevision: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroupBridgeSoftwareRevision',
                      id: args.id,
                    });
                  }
                },
              deploymentGroup: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroup',
                      id: args.id,
                    });
                  }
                },
              deploymentGroupTag: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeploymentGroupTag',
                      id: args.id,
                    });
                  }
                },
              deviceModel: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeviceModel',
                      id: args.id,
                    });
                  }
                },
              deviceNode: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeviceNode',
                      id: args.id,
                    });
                  }
                },
              deviceProvisioningClaim: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeviceProvisioningClaim',
                      id: args.id,
                    });
                  }
                },
              deviceType: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'DeviceType',
                      id: args.id,
                    });
                  }
                },
              edgeDevice: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDevice',
                      id: args.id,
                    });
                  }
                },
              edgeDeviceInstallState: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDeviceInstallState',
                      id: args.id,
                    });
                  }
                },
              edgeDeviceInstallStateHistory: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDeviceInstallStateHistory',
                      id: args.id,
                    });
                  }
                },
              edgeDeviceInstallStateSnapshot: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDeviceInstallStateSnapshot',
                      id: args.id,
                    });
                  }
                },
              edgeDeviceModelBridgeSnapDeclaration: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDeviceModelBridgeSnapDeclaration',
                      id: args.id,
                    });
                  }
                },
              edgeDeviceModel: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'EdgeDeviceModel',
                      id: args.id,
                    });
                  }
                },
              fleetAdministrator: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'FleetAdministrator',
                      id: args.id,
                    });
                  }
                },
              fleetAutoUpdateMode: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'FleetAutoUpdateMode',
                      id: args.id,
                    });
                  }
                },
              fleetBridgeSnapRevision: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'FleetBridgeSnapRevision',
                      id: args.id,
                    });
                  }
                },
              fleet: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Fleet',
                      id: args.id,
                    });
                  }
                },
              modelAssertion: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'ModelAssertion',
                      id: args.id,
                    });
                  }
                },
              roleBridgeScope: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'RoleBridgeScope',
                      id: args.id,
                    });
                  }
                },
              role: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Role',
                      id: args.id,
                    });
                  }
                },
              sbom: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Sbom',
                      id: args.id,
                    });
                  }
                },
              scope: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Scope',
                      id: args.id,
                    });
                  }
                },
              snapCategory: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapCategory',
                      id: args.id,
                    });
                  }
                },
              snapDeclaration: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapDeclaration',
                      id: args.id,
                    });
                  }
                },
              snapDelta: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapDelta',
                      id: args.id,
                    });
                  }
                },
              snapNamePolicy: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapNamePolicy',
                      id: args.id,
                    });
                  }
                },
              snapRevision: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapRevision',
                      id: args.id,
                    });
                  }
                },
              snapStatus: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapStatus',
                      id: args.id,
                    });
                  }
                },
              snapType: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapType',
                      id: args.id,
                    });
                  }
                },
              snapVisibilityPolicy: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SnapVisibilityPolicy',
                      id: args.id,
                    });
                  }
                },
              storeSetting: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'StoreSetting',
                      id: args.id,
                    });
                  }
                },
              systemUserAssertion: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'SystemUserAssertion',
                      id: args.id,
                    });
                  }
                },
              tenant: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Tenant',
                      id: args.id,
                    });
                  }
                },
              userBridgeRole: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'UserBridgeRole',
                      id: args.id,
                    });
                  }
                },
              user: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'User',
                      id: args.id,
                    });
                  }
                },
              userSession: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'UserSession',
                      id: args.id,
                    });
                  }
                },
              vulnerability: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'Vulnerability',
                      id: args.id,
                    });
                  }
                },
              vulnerabilityFinding: {
                  read(_ ,{ args, toReference }){
                  if (!args) return;
                    return toReference({
                      __typename: 'VulnerabilityFinding',
                      id: args.id,
                    });
                  }
                },
          }
        }
      }
      export default typePolicies
      